import * as Yup from "yup";

export const PACKAGE_LEVELS = [
  { id: "economy", name: "Economy" },
  { id: "medium", name: "Medium" },
  { id: "vip", name: "VIP" },
  { id: "luxury", name: "Luxury" },
];

export const initialValues = (data) => {
  return {
    ...data,
    cover_image: data?.cover_image,
    images: data?.images || [],
    event_type_id: data?.event_type?.id || data?.event_type_id || "",
    level: data?.level || "vip",
    name_en:
      data?.localized_data?.name_en ||
      data?.localized_data?.en?.name ||
      data?.name_en ||
      data?.name ||
      "",
    name_ar:
      data?.localized_data?.name_ar ||
      data?.localized_data?.ar?.name ||
      data?.name_ar ||
      "",
    description_en:
      data?.localized_data?.description_en ||
      data?.localized_data?.en?.description ||
      data?.description_en ||
      data?.description ||
      "",
    description_ar:
      data?.localized_data?.description_ar ||
      data?.localized_data?.ar?.description ||
      data?.description_ar ||
      "",
    max_guests: data?.max_guests ?? "",
    display_priority: data?.display_priority ?? "",
    is_active: data?.is_active ?? true,
    items: data?.items || [],
  };
};

export const structure = (_, __, t, eventTypes = [], onEventTypeChange) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `cover_image`,
        kind: "upload",
        type: "file",
        label: `${t("events_packages.cover_image")}*`,
        width: "100%",
      },
      {
        name: `images`,
        kind: "multiUpload",
        type: "file",
        label: t("events_packages.images"),
        width: "100%",
      },
      {
        name: `event_type_id`,
        kind: "select",
        type: "text",
        label: `${t("events_packages.event_type")}*`,
        width: "47%",
        options: eventTypes,
        changeAction: (value, formik) => {
          formik.setValues({ ...formik?.values, event_type_id: value });
          onEventTypeChange?.(value);
        },
      },
      {
        name: `level`,
        kind: "select",
        type: "text",
        label: `${t("events_packages.level")}*`,
        width: "47%",
        options: PACKAGE_LEVELS.map((l) => ({
          ...l,
          name: t(`events_packages.levels.${l.id}`, { defaultValue: l.name }),
        })),
      },
      {
        name: `name_en`,
        kind: "input",
        type: "text",
        label: `${t("events_packages.name_en")}*`,
        width: "47%",
      },
      {
        name: `name_ar`,
        kind: "input",
        type: "text",
        label: `${t("events_packages.name_ar")}*`,
        width: "47%",
      },
      {
        name: `description_en`,
        kind: "input",
        type: "text",
        label: t("events_packages.description_en"),
        width: "47%",
      },
      {
        name: `description_ar`,
        kind: "input",
        type: "text",
        label: t("events_packages.description_ar"),
        width: "47%",
      },
      {
        name: `max_guests`,
        kind: "input",
        type: "number",
        label: t("events_packages.max_guests"),
        width: "47%",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("events_packages.display_priority"),
        width: "47%",
      },
      {
        name: `is_active`,
        kind: "checkbox",
        type: "text",
        label: t("events_packages.is_active"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    cover_image: Yup.mixed().required("Required"),
    event_type_id: Yup.mixed().required("Required"),
    level: Yup.string().required("Required"),
    name_en: Yup.string().required("Required"),
    name_ar: Yup.string().required("Required"),
    max_guests: Yup.number().typeError("Must be a number").nullable(),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  });
